import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { verifyRecaptcha, registerUser } from "../../../../redux/authSlice";
import { RECAPTCHA } from "../../../UI/recaptcha";

export const Register = () => {
  const dispatch = useDispatch();
  const { loading, verified, error } = useSelector((state) => state.auth);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userFeedback, setUserFeedback] = useState({
    message: "",
    type: "info",
  });
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!recaptchaToken) {
      setUserFeedback({
        message: "Use the reCAPTCHA to confirm you are not a robot",
        type: "error",
      });
      return;
    }

    try {
      await dispatch(verifyRecaptcha(recaptchaToken)).unwrap();

      await dispatch(
        registerUser({ username, email, password, recaptchaToken })
      ).unwrap();

      setUserFeedback({
        message: "Registration Success!",
        type: "success",
      });

      // Clear reCAPTCHA token after submission
      setRecaptchaToken(null);
    } catch (err) {
      console.error("ERROR: ", err);
      setUserFeedback({ message: err.message, type: "error" });
    }
  };

  return (
    <div>
      <h2>Sign Up</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="username" className="htmlFor">
          Preferred Name
        </label>
        <br />
        <input
          id="username"
          type="username"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <br />
        <br />
        <label htmlFor="email" className="htmlFor">
          Email
        </label>
        <br />
        <input
          id="email"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <br />
        <br />
        <label htmlFor="password" className="htmlFor">
          Password
        </label>
        <br />
        <input
          id="password"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <br />
        <br />
        {/* <RECAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          onVerify={setRecaptchaToken}
          onExpire={() => setRecaptchaToken(null)}
          onError={() => setRecaptchaToken(null)}
        /> */}
        <button type="submit">Register</button>
        {userFeedback && (
          <div>
            <p className={`chroma-alert ${userFeedback.type}`}>
              {userFeedback.message}
            </p>
            {verified && <Link to="/">Return to login</Link>}
          </div>
        )}
      </form>
    </div>
  );
};
